import { BIDDING_TYPES } from "./enums";

type ComplexTypeOption = {
  id: number;
  title: string;
  value: string;
};

export const computeComplexType = (
  itemCount: number,
  complexTypes: ComplexTypeOption[]
): ComplexTypeOption => {
  if (itemCount >= 2) {
    return (
      complexTypes.find((t) => t.value === BIDDING_TYPES.JOINT) ??
      complexTypes[0]
    );
  }
  return (
    complexTypes.find((t) => t.value === BIDDING_TYPES.NORMAL) ??
    complexTypes[0]
  );
};
